import _objectSpread from "D:\\WorkeroAgent\\_work\\76\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "D:\\WorkeroAgent\\_work\\76\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["bounds", "url"];
import { createLayerComponent, updateMediaOverlay } from '@react-leaflet/core';
import { ImageOverlay as LeafletImageOverlay } from 'leaflet';
export var ImageOverlay = createLayerComponent(function createImageOveraly(_ref, ctx) {
  var bounds = _ref.bounds,
    url = _ref.url,
    options = _objectWithoutProperties(_ref, _excluded);
  var instance = new LeafletImageOverlay(url, bounds, options);
  return {
    instance: instance,
    context: _objectSpread(_objectSpread({}, ctx), {}, {
      overlayContainer: instance
    })
  };
}, function updateImageOverlay(overlay, props, prevProps) {
  updateMediaOverlay(overlay, props, prevProps);
  if (props.url !== prevProps.url) {
    overlay.setUrl(props.url);
  }
});